export type ClambersPuzzle = {
  sourceWord: string;
  letterOrder: string;
  acceptedAnswers: string[];
};

export function isClambersPuzzle(value: unknown): value is ClambersPuzzle {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<ClambersPuzzle>;
  if (
    typeof candidate.sourceWord !== 'string' ||
    !/^[a-z]{6}$/.test(candidate.sourceWord) ||
    typeof candidate.letterOrder !== 'string' ||
    !/^[a-z]{6}$/.test(candidate.letterOrder) ||
    !Array.isArray(candidate.acceptedAnswers) ||
    candidate.acceptedAnswers.length === 0 ||
    !candidate.acceptedAnswers.every((word) => typeof word === 'string' && /^[a-z]{6}$/.test(word))
  ) {
    return false;
  }
  const signature = [...candidate.sourceWord].sort().join('');
  return (
    [...candidate.letterOrder].sort().join('') === signature &&
    candidate.acceptedAnswers.includes(candidate.sourceWord) &&
    new Set(candidate.acceptedAnswers).size === candidate.acceptedAnswers.length &&
    candidate.acceptedAnswers.every((word) => [...word].sort().join('') === signature)
  );
}
